import { useState, useMemo } from 'react';
import useTranslation from 'Hooks/useTranslation';

const useDropDown = (roles = []) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState(t('Generic.All'));

  const filteredRoles = useMemo(() => {
    let result = roles;

    if (search.trim()) {
      result = result.filter(role => role.name.toLowerCase().includes(search.toLowerCase()));
    }

    if (status === t('Generic.Active')) {
      result = result.filter(role => role.active);
    } else if (status === t('Generic.Inactive')) {
      result = result.filter(role => !role.active);
    }

    return result;
  }, [roles, search, status]);

  return {
    setSearch,
    setStatus,
    filteredRoles,
  };
};

export default useDropDown;
